import { HttpClient } from '@angular/common/http';
import { Component, Injector, Input } from '@angular/core';
import { CoreClass } from '@src/app/core/base/core.class';
import { COMMON_MODULES, IMAGES_URL, ALL_SERVICES, COMPARE_MEDS_SEARCH } from '@src/app/core/constants';
import { HelperService } from '@src/app/core/services';
import { SearchInputComponent } from '../../search-input/search-input.component';
import { MiniEnvHeadingBlockComponent } from '../../ui/heading-box/mini-env-heading-block/mini-env-heading-block.component';

@Component({
  selector: 'app-search-medication',
  imports: [...COMMON_MODULES,
            SearchInputComponent,
            MiniEnvHeadingBlockComponent
  ],
  templateUrl: './search-medication.component.html',
  styleUrl: './search-medication.component.scss'
})
export class SearchMedicationComponent extends CoreClass {
    IMAGES_URL: string = IMAGES_URL;
    isLoading = false
    noData = false
    @Input() imgSrc: string = IMAGES_URL + 'aca-reading-man.svg';

    // public language: string = ""
    // style = 'font-size: 64px;line-height: 78px';
    constructor(
        injector: Injector,
    ) {
        super(injector);
    }
    All_SERVICES_PATH: string = ALL_SERVICES;
    membershipCode = ''


    getMedicines(drugName = '') {
        this.isLoading = true;
        let endpoint = this.sharedService.buildApiUrl(COMPARE_MEDS_SEARCH,{drugName})
        if (drugName == '') {
            this.isLoading = false
            this.sharedService.results = [];
            return;
        }

        console.log("testin end point", endpoint)

        this.httpService.requestEntity('GET', endpoint,)
            // .pipe(takeUntil(this.onDestroy$))
            .subscribe((res: any) => {

                let response = res.body;
                this.sharedService.results = response.data;
                this.isLoading = false
                response.data.length === 0 ? this.noData = true : this.noData = false
            },
                (error: any) => {
                    this.isLoading = false
                }
            )
    }
}
